import React from 'react'

import TextRow from '../../../../../../components/molecules/ChatModals/BaseModal/TextRow'
import PermissionsSection from './PermissionsSection'
import useStyles from './styles'

import { TextareaAutosize } from '@mui/material'
import { useRolesPermissions } from '../../../../../../providers/RolesPermissionsProvider'

const EditableContent = ({ setPermissionsArray }) => {
  const classes = useStyles()

  const { setToSaveObject, toSaveObject, data } = useRolesPermissions()

  // sends name to provider on blur
  const handleName = React.useCallback(
    e => {
      setToSaveObject(obj => ({ ...obj, name: e.target.value }))
    },
    [setToSaveObject]
  )

  // sends details to provider on blur
  const handleDetails = React.useCallback(
    e => {
      setToSaveObject(obj => ({ ...obj, details: e.target.value }))
    },
    [setToSaveObject]
  )

  return (
    <div className={classes.inputContainer}>
      <TextRow title={'Role Name'} className={classes.row}>
        <input
          defaultValue={toSaveObject?.name ?? data?.name ?? ''}
          placeholder='Enter name'
          maxLength='25'
          onBlur={handleName}
          disabled={data?.system}
          className={classes.input}
        />
      </TextRow>

      <TextRow title={'Role Details'} className={classes.row}>
        <TextareaAutosize
          defaultValue={toSaveObject?.details ?? data?.details ?? ''}
          placeholder='Enter details'
          onBlur={handleDetails}
          disabled={data?.system}
          className={classes.input}
        />
      </TextRow>

      <div className={classes.title}> Permissions </div>
      <PermissionsSection
        setPermissionsArray={setPermissionsArray}
        data={data}
      />
    </div>
  )
}

export default EditableContent
